import React from 'react'
import { Container } from './components/Styled'

interface Props {
  title?: string
  slug?: string
}

export const MainTitle: React.FC<Props> = ({ title }) => {
  return (
    <Container>
      <h1>{title}</h1>
    </Container>
  )
}
